export enum Alignments {
  start = 'flex-start',
  center = 'center',
  end = 'flex-end',
  stretch = 'stretch',
  between = 'space-between',
  around = 'space-around',
}
